import React from 'react';

import IOption from '@models/option';

import { InputLabel, SelectProps, useTheme } from '@mui/material';
import {
  FromControlStyled,
  MenuItemStyled,
  SelectStyled,
} from './select.styled';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface JSelectProps extends SelectProps {
  options: IOption[];
}

export const JSelect: React.FC<JSelectProps> = ({
  options,
  name,
  onClick,
  fullWidth,
  label,
  onChange,

  ...props
}) => {
  const theme = useTheme();

  return (
    <FromControlStyled variant="filled" fullWidth={fullWidth}>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <SelectStyled
        data-qa={`select-${name ?? label}`}
        {...props}
        IconComponent={(iconProps) => (
          <ChevronDownIcon {...iconProps} color={theme.palette.primary.main} />
        )}
        label={label}
        onChange={onChange}
      >
        {options.map((option) => (
          <MenuItemStyled
            key={option.value}
            value={option.value}
            data-qa={`${option.label}`}
          >
            {option.label}
          </MenuItemStyled>
        ))}
      </SelectStyled>
    </FromControlStyled>
  );
};
